exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vs__dropdown-menu{direction:rtl!important;text-align:right;left:unset;right:0}.vs__selected{padding:4px 8px;gap:8px}.orient-select{direction:rtl!important;text-align:right}", ""]);

// exports
